/**
 * 학년군별 교과 필터 선택지에서 제거할 subject_name 목록
 * Subjects without achievement standards in Neo4j
 */
export const SUBJECTS_WITHOUT_STANDARDS: Record<string, string[]> = {
  // 모든 학년군 공통
  '*': ['기타', '창의적 체험활동'],
  // 고등 한정
  고등: ['전문교과'],
  // 초등 한정 (중등/고등의 "정보"는 성취기준이 있으므로 제거하지 않음)
  초등: ['정보'],
};

/**
 * 학년군 ID 배열에서 학교급 판별
 *
 * @param gradeGroup - 학년 ID 배열 (5자리, 예: ["10101", "10102"])
 * @returns '초등' | '중등' | '고등' | null
 *
 * @example
 * getSchoolTypeFromGradeIds(['10101']) // '초등'
 * getSchoolTypeFromGradeIds(['10201']) // '중등'
 * getSchoolTypeFromGradeIds(['10301']) // '고등'
 */
export function getSchoolTypeFromGradeIds(
  gradeGroup: string[] | null,
): string | null {
  if (!gradeGroup || gradeGroup.length === 0) return null;

  // Check first ID's school type prefix (characters 0-2)
  const firstId = gradeGroup[0];
  const schoolTypeId = firstId.substring(0, 3);

  switch (schoolTypeId) {
    case '101':
      return '초등';
    case '102':
      return '중등';
    case '103':
      return '고등';
    default:
      return null;
  }
}

/**
 * 해당 학년군에서 제외해야 할 과목인지 판별
 *
 * @param schoolType - 학교급 ('초등' | '중등' | '고등')
 * @param subjectName - 과목명
 * @returns true if subject should be excluded from filter options
 *
 * @example
 * shouldExcludeSubject('초등', '기타') // true (global exclusion)
 * shouldExcludeSubject('초등', '정보') // true (elementary-specific)
 * shouldExcludeSubject('중등', '정보') // false (has standards for middle school)
 * shouldExcludeSubject('고등', '전문교과') // true (high school-specific)
 */
export function shouldExcludeSubject(
  schoolType: string | null,
  subjectName: string,
): boolean {
  // Check global exclusions
  if (SUBJECTS_WITHOUT_STANDARDS['*'].includes(subjectName)) {
    return true;
  }

  // Check school-specific exclusions
  if (
    schoolType?.startsWith('초등') &&
    SUBJECTS_WITHOUT_STANDARDS['초등'].includes(subjectName)
  ) {
    return true;
  }

  if (
    schoolType === '고등' &&
    SUBJECTS_WITHOUT_STANDARDS['고등'].includes(subjectName)
  ) {
    return true;
  }

  return false;
}
